import React, { useEffect } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Heading } from "@sunwing/wvi-components";
import { Section } from "../../components/Section";
import { usePageContext, useUser } from "../../context";
import { RCL as useTranslation } from "../../components/RCL";
import useGatsbyAuth from "../../templates/user-account/hook/useGatsbyAuth";
import { setBookingSearchBox, setLoaded } from "./setBookingSearchBox";

import * as styles from "./SearchBoxConnector.module.scss";

const SearchBoxConnector = ({ data, language, type, mode, classNames }) => {
	const { loading } = useGatsbyAuth();
	const { affiliate, isLoggedIn } = useUser();
	const alias = affiliate?.code || data?.[type]?.alias;
	const { preferredGateway } = usePageContext();
	const widgetTitle = useTranslation({ searchKey: "find-your-vacation-package" });

	useEffect(() => {
		let bsbScript;
		if (!loading) {
			bsbScript = document.createElement("script");
			bsbScript.src = process.env.GATSBY_WEB_CDN_BSB;
			bsbScript.async = true;
			bsbScript.defer = true;
			bsbScript.onload = () => {
				window.WEB_CDN_BSB.onLoad(() => {
					setLoaded(true);
					setBookingSearchBox(
						{
							from: preferredGateway?.value,
						},
						10,
						false
					);
				});
			};
			document.body.appendChild(bsbScript);
		}

		return () => {
			setLoaded(false);
			if (bsbScript) {
				if (window.WEB_CDN_BSB && window.WEB_CDN_BSB.destroy) {
					window.WEB_CDN_BSB.destroy();
				}

				bsbScript?.parentNode?.removeChild(bsbScript);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [alias, language, loading, mode, type]);

	// TODO: hotels check will be removed when WVI Hotels is ready for implementation
	if (type === "profile" || type === "hotels") {
		return null;
	}

	return (
		<Section
			className={styles.barWrapper}
			classNames={cx(styles.sectionContainer, classNames?.bsbWidgetMobileSectionContainer)}>
			<>
				<div className={cx(styles.bsbWidgetContainer, classNames?.bsbWidgetMobileContainer)}>
					{widgetTitle && (
						<Heading Tag="h3" size="sm" className={styles.heading}>
							{widgetTitle}
						</Heading>
					)}
					<div className={cx(styles.bar, styles[type === "other" ? "packages" : type])}>
						<div
							id="booking-search-box-wrapper"
							className={cx({ [styles.placeholder]: loading })}
							data-lang={language}
							data-alias={isLoggedIn ? alias : data?.[type]?.alias}
							data-type={type}
							data-mode={mode}
							data-brand="wvi"
						/>
					</div>
				</div>
			</>
		</Section>
	);
};

SearchBoxConnector.propTypes = {
	data: PropTypes.object.isRequired,
	mode: PropTypes.string,
	type: PropTypes.string,
	language: PropTypes.oneOf(["en", "fr"]),
	classNames: PropTypes.object,
};

SearchBoxConnector.defaultProps = {
	language: "en",
	type: "packages",
	mode: "search",
	classNames: undefined,
};

export { SearchBoxConnector };
